<cdk-virtual-scroll-viewport itemSize="50" *ngIf="timelineEntries && timelineEntries.length" class="vb-scrollbar">
	<pulse-timeline-entry *cdkVirtualFor="let entry of timelineEntries; index as $index" [isActive]="entry === activeEntry" [entry]="entry" [canEdit]="video.canEditVideo" [openedEdit]="editEntry" [showHours]="isShowHours" [dropup]="timelineEntries.length > 4 && $index >= timelineEntries.length - 2" (onSelect)="onSelect($event)" (onEditToggled)="editEntry = $event" (onEdit)="onEdit($event, entry)">
	</pulse-timeline-entry>
</cdk-virtual-scroll-viewport>

<div class="text-align-center margin-top-20" [hidden]="!(VideoPulse.isTranscriptAvailable$ | async) || timelineEntries?.length">
	{{ 'NoResultsFound' | translate }}
</div>

<div class="text-align-center margin-top-20" *ngIf="!(VideoPulse.isTranscriptAvailable$ | async)">
	{{ 'Media_Videos_Pulse_NoTranscriptFound' | translate }}
</div>
